import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StaffCummunicationService {
  private staffCommunication = new Subject<any>();
  constructor() { }

  setStaffCommunication(data: any) {
    this.staffCommunication.next(data);
  }

  getStaffCommunication() {
    return this.staffCommunication.asObservable();
  }
}
